<script setup>
	import { defineProps, defineEmits } from 'vue'
    import Chat from '../Chat.vue'

	const props = defineProps({
		question: {
			type: Object,
			required: true
		}
	})
    console.log(props.question);
    const emit = defineEmits(['proceed'])
</script>

<template>
    <section class="btn-options">
        <h3 class="questionHeading">{{ question.headline }}</h3>
   
        <div class="radioBtn" v-for="option in question.options" :key="question.id">
            <input type="radio" :id="question.id + '-' + option.value" :name="question.id" :value="option.value" v-model="question.value" @click="$emit('proceed', option.value)"/>
            <label :for="question.id + '-' + option.value">{{ option.text }}</label>
        </div>

        <!-- <div v-if="question.showTooltip" style="text-align: center; margin-top: 30px; margin-bottom: -15px;">
            <ul style="list-style: none; padding: 0;">
                <li><i class="fas fa-check" style="color: green; margin-right: 8px;"></i>Be debt-free in as little as 24–48 months</li>
                <li><i class="fas fa-check" style="color: green; margin-right: 8px;"></i>One significantly lower monthly payment</li>
                <li><i class="fas fa-check" style="color: green; margin-right: 8px;"></i>No credit score impact to apply</li>
            </ul>
        </div> -->

        <div v-if="question.chat">
            <Chat :message="question.chat" />
        </div>
        
    </section>
</template>

<style scoped>
    .questionHeading {
        font-size: 1.6em;
        font-weight: 700;
        color: #2a2a2b;
        text-align: center;
        line-height: 1.2;
        margin-bottom: 25px;
    }
    .radioBtn {
        position: relative;
        display: block;
    }

    .radioBtn label {
        position: relative;
        display: block;
        background: #fff;
        color: #0B3954;
        border-radius: 1px;
        padding: 20px 15px;
        border: 1px solid #0B3954;
        margin-bottom: 10px;
        cursor: pointer;
        box-shadow: 0 3px 0 #dbdBE866;
        text-align: center;
        font-size: 1.2em;
        font-weight: 600;
    }
    .radioBtn label.v2 {
        background: #0B3954;
        color: #fff;
        border-color: #fff;
        padding: 15px 15px;
        box-shadow: rgba(0,0,0,.5) 0 .125rem .25rem;
    }
    input[type="radio"] {
        display: none;
        position: absolute;
        width: 100%;
        appearance: none;
    }
    input[type="radio"]:checked + label:before {
        content: "";
        position: absolute;
        display: block;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-color: #0B3954;
        border-width: 2px;
        border-style: solid;
    }
    input[type="radio"]:checked + label:after {
        content: "\f058";
        position: absolute;
        display: inline-block;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        font: var(--fa-font-regular);
        color: #0B3954;
        right: 10px;
        top: calc(50% - .5em);
        font-size: 1.5em;
    }
</style>
